import { put, select, takeEvery } from "redux-saga/effects";

import { IntegrationBusinessAction } from "actions";

import { INTEGRATION_BUSINESS } from "constants/actionTypes";

import { getBusinessById, getIntegrationBusinessById } from "selectors";

function* onLinkToBusiness(action) {
  const { id, businessId, options } = action;

  const state = yield select();

  const integrationBusiness = getIntegrationBusinessById(id)(state);

  const newBusiness = getBusinessById(businessId)(state);

  const { businessId: oldBusinessId } = integrationBusiness;
  if (oldBusinessId && oldBusinessId !== newBusiness.id) {
    yield put(
      IntegrationBusinessAction.unlinkFromBusiness(id, oldBusinessId, {
        localUnlinkOnly: true,
      }),
    );
  }

  yield put(
    IntegrationBusinessAction.update(
      {
        id,
        businessId: newBusiness.id,
        credentialsId: integrationBusiness.credentialsId,
      },
      options,
    ),
  );
}

function* onUnlinkFromBusiness(action) {
  const { id, options } = action;

  const state = yield select();

  const integrationBusiness = getIntegrationBusinessById(id)(state);

  const { localUnlinkOnly = false } = options || {};
  if (localUnlinkOnly) {
    return;
  }

  yield put(
    IntegrationBusinessAction.update(
      {
        id,
        businessId: null,
        credentialsId: integrationBusiness.credentialsId,
      },
      options,
    ),
  );
}

export default function* saga() {
  yield takeEvery(
    INTEGRATION_BUSINESS.LINK_TO_BUSINESS.ACTION,
    onLinkToBusiness,
  );
  yield takeEvery(
    INTEGRATION_BUSINESS.UNLINK_FROM_BUSINESS.ACTION,
    onUnlinkFromBusiness,
  );
}
